import {select, fork, put, take} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';

const fetchContractPartnerRouteFlow = function* fetchContractPartnerRouteFlow({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const googleMapsService = serviceManager.loadService('googleMapsService');

    const {originLocation, destinationLocation, serviceAssignmentId} = payload;
    const {contractPartnerId = null, isManuallyAdded = false} = payload;
    const {serviceAssignments} = yield select(state => state.serviceAssignments);
    const serviceAssignment = serviceAssignments[serviceAssignmentId];

    if (!serviceAssignment) return;

    const {contractPartnerRecommendations} = serviceAssignment;

    if (contractPartnerRecommendations?.find(contractPartner => (
        contractPartner.id === contractPartnerId && contractPartner.routeToDamageLocation?.encodedPolyline
    ))) return;

    yield fork(
        fetchRequest,
        serviceAssignmentActionTypes.FETCH_CONTRACT_PARTNER_ROUTE_REQUEST,
        googleMapsService.getRoute,
        {
            origin: {
                location: {
                    latLng: {
                        latitude: originLocation?.latitude,
                        longitude: originLocation?.longitude,
                    },
                },
            },
            destination: {
                location: {
                    latLng: {
                        latitude: destinationLocation?.latitude,
                        longitude: destinationLocation?.longitude,
                    },
                },
            },
            fields: ['routes.distanceMeters', 'routes.duration', 'routes.polyline.encodedPolyline'],
        },
    );

    const responseAction = yield take([
        serviceAssignmentActionTypes.FETCH_CONTRACT_PARTNER_ROUTE_REQUEST_FAILED,
        serviceAssignmentActionTypes.FETCH_CONTRACT_PARTNER_ROUTE_REQUEST_SUCCEEDED,
    ]);

    if (responseAction.error) return;

    const {response: routeResponse} = responseAction.payload;

    if (!routeResponse?.routes?.[0]) return;

    if (isManuallyAdded) {
        yield put({
            type: serviceAssignmentActionTypes.SET_DAMAGE_LOCATION_TO_ACE_PARTNER_ROUTE,
            payload: {
                routeToReferentialPoint: {
                    totalKilometers: routeResponse.routes[0].distanceMeters / 1000,
                    totalTravelTime: Number(routeResponse.routes[0].duration.replace('s', '')) / 60,
                    encodedPolyline: routeResponse.routes[0].polyline.encodedPolyline,
                },
                serviceAssignmentId,
            },
        });
        return;
    }

    yield put({
        type: serviceAssignmentActionTypes.SET_DAMAGE_LOCATION_TO_CONTRACT_PARTNER_ROUTE,
        payload: {
            serviceAssignmentId,
            contractPartnerId,
            routeToDamageLocation: {
                totalTravelTime: Number(routeResponse.routes[0].duration.replace('s', '')) / 60,
                totalKilometers: routeResponse.routes[0].distanceMeters / 1000,
                encodedPolyline: routeResponse.routes[0].polyline?.encodedPolyline,
            },
        },
    });
};

export default fetchContractPartnerRouteFlow;
